import { memo, useCallback, useState } from "react";
import { Col, Container, Popover, Row } from "react-bootstrap";
import { BzButton, BzPopoverOverlay, BzToolTip } from "../../components";
import { useLeftClick, useWFHMessages } from "../../hooks";
import { clickWithOutModifiers, convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, globalFunctionsEventDispatcher, isUserIsAGuest, setOrderEntryScripPrice } from "../../utils/global_functions";
import { FACILITY_NUM, GLOBAL_FUNCTION_TYPES, OPTION_CHAIN, OPTION_CHAIN_GRID_INDEX } from "../../utils/global_variables";
import { useDispatch, useSelector } from "react-redux";
import { clearOptionChain, toggleOptionChainCheckBox, updateLegDataForOptionChain } from "../../redux/actions/optionChain";
import { handleModal } from "../../redux/actions/modals";
import { _getScripsInfo } from "../../controllers";
import { getScripOrderInfo } from "../../redux/actions/orders";
import { setArrScripToBeAdded } from "../../redux/actions/globalSearch";

const OptionChainToolTip = ({ arrRowData, children, ...props }) => {

    const dispatch = useDispatch();

    const isToggle = useSelector(state => state?.optionChain?.isToggle);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    
    const [showPopover, setShowPopover] = useState(false);

    const resetAllConditionsOnModalOpen = useCallback(() => {
        setShowPopover(false);
        dispatch(updateLegDataForOptionChain());
        dispatch(clearOptionChain());
    }, [dispatch]);


    useWFHMessages('global_function', (e) => {
        if (e?.detail?.length > 0) {
            e?.detail?.forEach((eachType) => {
                switch (eachType) {
                    case GLOBAL_FUNCTION_TYPES.SCROLLING_OPTION_CHAIN:
                        if (showPopover) {
                            setShowPopover(false);
                        }
                        break;

                    default:
                        break;
                }
            });
        }
    });

    /*
    Below function adds slected scrip to watchlist
    */
    const addScripModal = useCallback(async () => {
        setShowPopover(false);
        const marketID = props?.colDef?.type === OPTION_CHAIN.CALL ? arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[0] : arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[0];
        const token = props?.colDef?.type === OPTION_CHAIN.CALL ? arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[1] : arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[1];
        const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(marketID), token: token }]);
        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
        const scripData = convertScripResponseWatchlistGrid(scripDataObj);
        dispatch(setArrScripToBeAdded(scripData));
        dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': true }]));
        convertScripResponseWatchlistGrid();

    }, [dispatch, arrRowData, resetAllConditionsOnModalOpen, props?.colDef?.type]);

    /*
    Below function handle BUY and SELL of selected scrip
    */
    const handleOrderEntryModal = useCallback(async (nIsBuyOrSell) => {
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 20-03-2024 - BT-1207722 - Breeze -Guest User Privileges
            const marketID = props?.colDef?.type === OPTION_CHAIN.CALL ? arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[0] : arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[0];
            const token = props?.colDef?.type === OPTION_CHAIN.CALL ? arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[1] : arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[1];
            resetAllConditionsOnModalOpen();
            const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(marketID), token: token }]);
            const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
            const scripData = convertScripResponseWatchlistGrid(scripDataObj);
            dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: marketID, scripData: scripData[0] }));
            setOrderEntryScripPrice(nIsBuyOrSell, scripData[0]);
            await dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }, { 'OPTION_CHAIN': false }, { 'ORDER_ENTRY_MODAL': true }]));
            globalFunctionsEventDispatcher([GLOBAL_FUNCTION_TYPES.CLOSING_SIDETRAY]); 
        } else { }
    }, [arrRowData, resetAllConditionsOnModalOpen, props?.colDef?.type, dispatch]);

    /*
    Below function toggles option chain into multileg order 
    */
    const toggleMultilegCheckBox = useCallback(() => {
        dispatch(toggleOptionChainCheckBox(true));
        setShowPopover(false);
    }, [dispatch]);

    const BzPopover = (
        <Popover className='optiochain-popover'>
            {
                <>
                    <Popover.Header className='d-flex flex-column'>
                        <Container fluid className='p-0'>
                            <Row className='g-0 py-2 popover-menu'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <BzButton className='btn btn-positive btn-sm text-uppercase me-1'
                                        onClick={handleOrderEntryModal.bind(this, 0)}
                                    >Buy</BzButton>
                                    <BzButton className='btn btn-negative btn-sm text-uppercase ms-1'
                                        onClick={handleOrderEntryModal.bind(this, 1)}
                                    >Sell</BzButton>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Add to watchlist'}>
                                        <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center ms-2'
                                            onClick={addScripModal}
                                        >
                                            <div class="icon-20 icon-add-circle icon-primary"></div>
                                        </button>
                                    </BzToolTip>
                                </Col>
                            </Row>
                            {
                                objCFT.MULTILEG === FACILITY_NUM.ON ?
                                    <Popover.Body className='d-flex flex-column'>
                                        <div className='bdr-top'>
                                            <Row className={`g-0 py-2 popover-menu`}>
                                                <Col className='d-flex align-items-center' onClick={toggleMultilegCheckBox}>
                                                    <input type='checkbox' id='create_multileg_order' className='form-check-input' />
                                                    <label htmlFor='create_multileg_order' className='font-regular font-size3 color-text ms-2 p-t-1'>Create Multileg Order</label>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Popover.Body> : null
                            }
                        </Container>
                    </Popover.Header>
                </>
            }
        </Popover>
    );

    const leftClick = useCallback((e) => {
        if (e?.button === 0) {
            setShowPopover(false);
        }
    }, []);
    const [targetElement] = useLeftClick(leftClick);
    const onContextMenu = useCallback((e) => {
        if (!clickWithOutModifiers(e) || isToggle) {
            return;
        }
        setShowPopover(true);
    }, [isToggle]);
    return (
        <BzPopoverOverlay rootClose trigger='click' show={showPopover} onToggle={() => setShowPopover(false)} placement={'bottom'} popover={BzPopover}>
            <div ref={targetElement} onClick={onContextMenu}>
                {children}
            </div>
        </BzPopoverOverlay>
    );
};


export default memo(OptionChainToolTip);